var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0383 5.87695C14.9728 5.86632 14.9066 5.86142 14.8403 5.86228H3.55261L3.79874 5.7478C4.03932 5.63392 4.2582 5.47896 4.44555 5.28988L7.6109 2.12453C8.02778 1.72658 8.09783 1.08639 7.77689 0.607685C7.40337 0.097573 6.68705 -0.0131855 6.1769 0.360338C6.13568 0.390529 6.09653 0.423444 6.0597 0.458862L0.335747 6.18282C-0.11158 6.62965 -0.111973 7.35448 0.334853 7.80181L0.335747 7.8027L6.0597 13.5267C6.50739 13.9731 7.23222 13.9721 7.67869 13.5244C7.71382 13.4892 7.74663 13.4517 7.77689 13.4122C8.09783 12.9335 8.02778 12.2933 7.6109 11.8953L4.45127 8.72426C4.28332 8.55611 4.09021 8.41514 3.87888 8.30641L3.53544 8.15186H14.7773C15.3621 8.17358 15.8752 7.76506 15.985 7.19024C16.0863 6.56615 15.6624 5.97819 15.0383 5.87695Z",
    fill: "#555555"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevronLeft.c78dde2cbe4e5bfa1e2579edb3c5ed29.svg";
export { ForwardRef as ReactComponent };